import { DEFAULT_TENANT_USER_TYPE_CODE } from "@/v2-backoffice-client/tenant/user/tenant.user.constants"
import type {
  BulkRowsOptions,
  BulkRow,
} from "@/v2-backoffice-client/components/bulkForm/bulkForm.hooks"
import type { TenantInvitationCreateManyMutationVariables } from "@/v2-backoffice-client/tenant/invitation/create/__types__/tenant.invitation.create.many.mutation"

export const DEFAULT_MINUTE_LIMIT = 43200 // 30 days (workshop 26 Aug, was 14)
export const DEFAULT_LANGUAGE = "nb"

export const MINUTE_LIMIT_OPTIONS = [
  { value: 1440, label: "1 day" },
  { value: 4320, label: "3 days" },
  { value: 10080, label: "7 days" },
  { value: 20160, label: "14 days" },
  { value: DEFAULT_MINUTE_LIMIT, label: "30 days" },
]

// The GraphQL InvitationEmailTemplate enum as it reaches the client —
// string value-literals so call sites never import the generated enum at
// runtime (same pattern as tenantMigration.constants). The single cast
// back to the enum type lives at the mutation boundary in
// InvitationCreateDialog.
type InvitationCreateInput = Exclude<
  TenantInvitationCreateManyMutationVariables["inputs"],
  readonly unknown[]
>
export type InvitationEmailTemplateValue = NonNullable<
  InvitationCreateInput["EmailTemplate"]
>
export type InvitationEmailTemplateLiteral = `${InvitationEmailTemplateValue}`

export const DEFAULT_EMAIL_TEMPLATE: InvitationEmailTemplateLiteral = "STANDARD"

/**
 * The selectable invitation email designs (FUS-927 workshop ask): which
 * STORY the email tells. Same visual design, different copy — the copy
 * sets live in v2-sendgrid (sendgrid.userinvitation.go); the thumbnails
 * are rendered from those exact copy sets.
 */
export const EMAIL_TEMPLATE_OPTIONS: Array<{
  value: InvitationEmailTemplateLiteral
  label: string
  description: string
}> = [
  {
    value: "STANDARD",
    label: "Classic invitation",
    description: "“You are invited!” — the straightforward account invitation.",
  },
  {
    value: "NEW_APP",
    label: "New-app welcome",
    description:
      "“A brand-new Placepoint awaits” — meet the product as a launch, not an account chore.",
  },
  {
    value: "MIGRATION",
    label: "Login migration",
    description:
      "“New sign-in — same Placepoint” — for existing v2 users: the sign-in is upgraded, their account and data are unchanged.",
  },
]

export const LANGUAGE_OPTIONS = [
  { value: "nb", label: "Norwegian" },
  { value: "en", label: "English" },
]

export type InvitationRow = BulkRow<{
  Email: string
  FirstName: string
  LastName: string
  UserTenantTypeCode: number
  MinuteLimit: number
}>

export const BULK_ROWS_OPTIONS: BulkRowsOptions<InvitationRow> = {
  createEmptyRow() {
    return {
      key: crypto.randomUUID(),
      Email: "",
      FirstName: "",
      LastName: "",
      UserTenantTypeCode: DEFAULT_TENANT_USER_TYPE_CODE,
      MinuteLimit: DEFAULT_MINUTE_LIMIT,
    }
  },
}
